export const PERCENTAGE_ERROR_STATUS = 0.33;
export const PERCENTAGE_WARNING_STATUS = 0.66;

export enum Status {
  Unknown,
  Error,
  Warning,
  Success,
}

export const translateStatus = (statusLevel?: number): Status => {
  if (
    statusLevel === undefined
    || statusLevel < 0
    || statusLevel > 1
    || !Number.isFinite(statusLevel)
  ) {
    return Status.Unknown;
  } else if (statusLevel <= PERCENTAGE_ERROR_STATUS) {
    return Status.Error;
  } else if (statusLevel <= PERCENTAGE_WARNING_STATUS) {
    return Status.Warning;
  }
  return Status.Success;
};

export type RangeResult = {
  slots: SlotData[];
  slotSizeInMinutes: number;
};
export type SlotData = { startTimeMillis: number; value: number };
